import { useCallback, useEffect } from "react";
import { AttributeAPI } from "@griffingroupglobal/eslib-api";
import { useAppState } from "../state/appState";
import { SET_ATTRIBUTES } from "../constants";

export default () => {
  const [{ attributes, selectedAttributes }, dispatch] = useAppState();

  const reload = useCallback(async () => {
    const { data } = await AttributeAPI.get();
    const selected = [];

    // TODO: When updating to React-Query keep this alphabetical search in for SnC table
    // SnC is still using index to edit/delete attributes so mutate array prior to table view
    const sortedData = data?.entries?.sort((a, b) => {
      const nameA = a?.resource?.detail?.toLowerCase();
      const nameB = b?.resource?.detail?.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    dispatch({
      type: SET_ATTRIBUTES,
      attributes: sortedData?.map((entry) => {
        if (entry.resource?.selected) {
          selected.push(entry.resource);
        }
        return entry.resource;
      }),
      selectedAttributes: selected,
    });
  }, [dispatch]);

  useEffect(() => {
    reload();
  }, [reload]);

  return [attributes, reload, selectedAttributes];
};
